import axios from 'axios';
import findIndex from 'lodash/findIndex';
import { cloneDeep, find, some } from 'lodash';
import moment from 'moment';
import * as types from '../actionTypes';
import * as urls from '../urlTypes';
import { toastError } from '../../util/toastUtils';
import {
  _distReqDupliCheck,
  _distFormatCamp,
  _sortCampaignList,
  formatCampaignDetails,
  _checkUnsavedChanges,
  _getCampaignStatus,
} from '../../util/deUtils';
import { CopyDataToClipBoardModal } from '../../util/CommonUtils'

export const _getDestinations = async accountId => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/partnersList/${accountId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.data.status !== 200) {
      toastError(response.data.message);
      return false;
    }
    if (response.data && response.data.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get Destinations');
    return false;
  }
};

export const getDestinations = () => async (dispatch, getState) => {
  const accountId = getState().account.activeAccountId;
  dispatch({
    type: types.GET_DE_DESTINATION_REQUEST,
  });

  const destinations = await _getDestinations(accountId);
  if (destinations) {
    dispatch({
      type: types.GET_DE_DESTINATION_SUCCESS,
      response: destinations,
    });
  } else {
    dispatch({
      type: types.GET_DE_DESTINATION_FAILURE,
    });
  }
};

export const setDistRequestName = reqName => async dispatch => {
  dispatch({
    type: types.SET_DE_DIST_REQUEST_NAME,
    reqName,
  });
};

export const _saveEditDistributeCampaign = async (
  accountId,
  requestId,
  reqParam
) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/editCampaign/${accountId}/${requestId}`;
  try {
    const response = await axios({
      url,
      method: 'post',
      responseType: 'json',
      data: reqParam,
      withCredentials: true,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.data.status !== 200) {
      toastError(response.data.message);
      return false;
    }
    if (response.data && response.data.status === 200) {
      return _sortCampaignList(response.data.data);
    }
    return false;
  } catch (error) {
    toastError('Api failed to save edit campaign.');
    return false;
  }
};
export const _saveDistributeCampaign = async (
  accountId,
  targetId,
  reqParam
) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/saveCampaign/${accountId}/${targetId}`;
  try {
    const response = await axios({
      url,
      method: 'post',
      responseType: 'json',
      withCredentials: true,
      data: reqParam,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.data.status !== 200) {
      toastError(response.data.message);
      return false;
    }
    if (response.data && response.data.status === 200) {
      return _sortCampaignList(response.data.data);
    }
    return false;
  } catch (error) {
    toastError('Api failed to save campaign.');
    return false;
  }
};

export const setDistRequest = (payload, temp = false) => async dispatch => {
  const type = temp
    ? types.SET_CAMPAIGN_DETAILS_TEMP
    : types.SET_CAMPAIGN_DETAILS;
  dispatch({
    type,
    payload,
  });
};

export const resetDestRequest = () => async dispatch => {
  dispatch({
    type: types.SET_CAMPAIGN_DETAILS,
  });
};

export const setTargetDistribute = (target, temp) => async dispatch => {
  if (!temp) {
    dispatch(resetDestRequest());
  }
  const type = temp
    ? types.SET_TARGET_DISTRIBUTE_TEMP
    : types.SET_TARGET_DISTRIBUTE;
  dispatch({
    type,
    payload: target,
  });
};

export const setCampaignDataToForm = (data, temp = false) => dispatch => {
  const distRequest = formatCampaignDetails(data);
  dispatch(setTargetDistribute(data.target, temp));
  dispatch(setDistRequest(distRequest, temp));
};
export const _validateDistCamp = () => async (dispatch, getState) => {
  const state = getState();
  let errCnt = 0;
  if (!state.deDistribute.distRequest.name) {
    errCnt += 1;
    dispatch({
      type: types.DE_DIST_ADD_TO_QUEUE_NAME_ERR,
      isErrMsg:
        'Request name is a required field. Please enter a name to continue.',
    });
  } else if (
    _distReqDupliCheck(
      state.deDistribute.distRequest,
      state.deDistribute.distributeData.data
    ) > 0
  ) {
    errCnt += 1;
    dispatch({
      type: types.DE_DIST_ADD_TO_QUEUE_NAME_ERR,
      isErrMsg:
        'A request with this name already exists. Please enter a unique name.',
    });
  } else {
    dispatch({
      type: types.DE_DIST_ADD_TO_QUEUE_NAME_ERR_RESET,
    });
  }

  if (
    state.deDistribute.selectedTarget === null ||
    !state.deDistribute.selectedTarget.name
  ) {
    errCnt += 1;
    dispatch({
      type: types.DE_DIST_ADD_TO_QUEUE_TARGET_ERR,
      isErrMsg:
        'Target selection is a required field. Please select a target to continue.',
    });
  } else {
    dispatch({
      type: types.DE_DIST_ADD_TO_QUEUE_TARGET_ERR_RESET,
    });
  }
  if (
    state.deDistribute.distRequest.isForActivation &&
    (!state.deDistribute.distRequest.startDate ||
      !state.deDistribute.distRequest.endDate)
  ) {
    errCnt += 1;
    dispatch({
      type: types.DE_DIST_ADD_TO_QUEUE_DATE_ERR,
      isErrMsg:
        'Start and end dates are required fields. Please enter a date to continue.',
    });
  } else {
    dispatch({
      type: types.DE_DIST_ADD_TO_QUEUE_DATE_ERR_RESET,
    });
  }
  if (errCnt === 0) {
    return true;
  }
  return false;
};

export const addDistToQueue = () => async (dispatch, getState) => {
  const { deDistribute, account } = getState();
  const isValidate = await dispatch(_validateDistCamp());
  const accountId = account.activeAccountId;

  if (isValidate && deDistribute.distRequest.requestId !== '') {
    const requestId = deDistribute.distRequest.requestId;
    const finalReqParam = _distFormatCamp(
      deDistribute.distRequest,
      deDistribute.selectedTarget.id
    );
    const campaignList = await _saveEditDistributeCampaign(
      accountId,
      requestId,
      finalReqParam
    );
    if (campaignList) {
      const updatedCampaign = campaignList.find(({ id }) => id === requestId);
      dispatch(setCampaignDataToForm(updatedCampaign));
      dispatch({
        type: types.GET_DE_CAMPAIGNLIST_SUCCESS,
        response: campaignList,
      });
    }
  } else if (isValidate && deDistribute.distRequest.requestId === '') {
    const targetId = deDistribute.selectedTarget.id;
    const finalReqParam = _distFormatCamp(
      deDistribute.distRequest,
      deDistribute.selectedTarget.id
    );
    const campaignList = await _saveDistributeCampaign(
      accountId,
      targetId,
      finalReqParam
    );
    if (campaignList) {
      const campName = deDistribute.distRequest.name;
      const campaignIndex = findIndex(
        campaignList,
        campaign => campaign.campName === campName
      );
      dispatch({
        type: types.GET_DE_CAMPAIGNLIST_SUCCESS,
        response: campaignList,
      });
      dispatch(setCampaignDataToForm(campaignList[campaignIndex]));
    }
  }
};

export const setDistFromToDate = (fromDate, toDate) => async dispatch => {
  dispatch({
    type: types.SET_DE_DIST_FROM_TO_DATE,
    fromDate: fromDate
      ? moment(fromDate).format('YYYY-MM-DD HH:mm:ss')
      : fromDate,
    toDate: toDate ? moment(toDate).format('YYYY-MM-DD HH:mm:ss') : toDate,
  });
};

export const setDistForActivation = activationState => async dispatch => {
  dispatch({
    type: types.SET_DE_DIST_FOR_ACTIVATION,
    activationState,
  });
};

export const resetDistributeObj = () => async dispatch => {
  dispatch({
    type: types.RESET_DE_DISTRIBUTE,
  });
};

export const _getCampaignList = async (accountId, impersonateMode) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/campaignList/${accountId}?impersonateMode=${impersonateMode}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.data.status !== 200) {
      toastError(response.data.message);
      return false;
    }
    if (response.data && response.data.status === 200) {
      return _sortCampaignList(response.data.data);
    }
    return false;
  } catch (error) {
    toastError('Api failed to get Campaign List');
    return false;
  }
};

export const getCampaignList = () => async (dispatch, getState) => {
  const state = getState();
  const accountId = state.account.activeAccountId;
  const impersonateMode = state.login.loginResponse.data.impersonated;
  dispatch({
    type: types.GET_DE_CAMPAIGNLIST_REQUEST,
  });
  const campaignList = await _getCampaignList(accountId, impersonateMode);
  if (campaignList) {
    dispatch({
      type: types.GET_DE_CAMPAIGNLIST_SUCCESS,
      response: campaignList,
    });
  } else {
    dispatch({
      type: types.GET_DE_CAMPAIGNLIST_FAILURE,
    });
  }
};

export const _askForUnsavedChanges = isModal => async dispatch => {
  dispatch({
    type: types.ASK_DE_REQUEST_CHANGES,
    payload: isModal,
  });
};

export const checkUnsavedChanges = isDistribute => (dispatch, getState) => {
  const { deDistribute } = getState();
  const { distRequest, distributeData } = deDistribute;
  const hasUnsavedChanges = _checkUnsavedChanges(distRequest, distributeData);
  if (!isDistribute) {
    dispatch(_askForUnsavedChanges(hasUnsavedChanges));
  }
  return hasUnsavedChanges;
};

export const setDistributeModal = isOpen => async dispatch => {
  dispatch({
    type: types.SET_DISTRIBUTE_MODAL,
    currentState: isOpen,
  });
};

export const distributeCampaign = () => async dispatch => {
  const isValidate = await dispatch(_validateDistCamp());
  if (isValidate) {
    dispatch(setDistributeModal(isValidate));
  }
};

export const _submitDistCampaign = async (accountId, requestId, jiraId) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/distribute/${accountId}/${requestId}?jiraId=${jiraId}`;
  try {
    const response = await axios({
      url,
      method: 'post',
      responseType: 'json',
      withCredentials: true,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.data.status !== 200) {
      toastError(response.data.message);
      return false;
    }
    if (response.data && response.data.status === 200) {
      return _sortCampaignList(response.data.data);
    }
    return false;
  } catch (error) {
    toastError('Api failed to distribute campaign.');
    return false;
  }
};

export const submitDistCampaign = () => async (dispatch, getState) => {
  const { deDistribute, account } = getState();
  const accountId = account.activeAccountId;
  const requestId = deDistribute.distRequest.requestId;
  const jiraId = deDistribute.distRequest.jiraId
    ? deDistribute.distRequest.jiraId
    : '';
  let addToQueueRes;
  const finalReqParam = _distFormatCamp(
    deDistribute.distRequest,
    deDistribute.selectedTarget.id
  );
  if (!requestId || dispatch(checkUnsavedChanges(true))) {
    if (!requestId) {
      addToQueueRes = await _saveDistributeCampaign(
        accountId,
        deDistribute.selectedTarget.id,
        finalReqParam
      );
    } else {
      addToQueueRes = await _saveEditDistributeCampaign(
        accountId,
        requestId,
        finalReqParam
      );
    }
    if (addToQueueRes) {
      const campName = deDistribute.distRequest.name;
      const campaign = find(
        addToQueueRes,
        campaign => campaign.campName === campName
      );
      const distRequestId = requestId || campaign.id;
      const addToQueueCampaign = addToQueueRes.find(
        ({ id }) => id === distRequestId
      );
      dispatch(setCampaignDataToForm(addToQueueCampaign));
      dispatch({
        type: types.GET_DE_CAMPAIGNLIST_SUCCESS,
        response: addToQueueRes,
      });
      const campaignList = await _submitDistCampaign(
        accountId,
        distRequestId,
        jiraId
      );
      if (campaignList) {
        const updatedCampaign = campaignList.find(
          ({ id }) => id === distRequestId
        );
        dispatch(setCampaignDataToForm(updatedCampaign));
        dispatch({
          type: types.GET_DE_CAMPAIGNLIST_SUCCESS,
          response: campaignList,
        });
        dispatch(setDistributeModal(false));
        dispatch(setComfirmRequest(true));
      }
    }
  } else {
    const campaignList = await _submitDistCampaign(
      accountId,
      requestId,
      jiraId
    );
    if (campaignList) {
      const updatedCampaign = campaignList.find(({ id }) => id === requestId);
      dispatch(setCampaignDataToForm(updatedCampaign));
      dispatch({
        type: types.GET_DE_CAMPAIGNLIST_SUCCESS,
        response: campaignList,
      });
      dispatch(setDistributeModal(false));
      dispatch(setComfirmRequest(true));
    }
  }
};

export const setDestinationDetails = (partner, isRemove) => (
  dispatch,
  getState
) => {
  const state = getState();
  const destList = state.deDistribute.distRequest.dest;
  let payload = [];
  if (isRemove) {
    payload = destList.filter(elem => elem.id !== partner.id);
  } else {
    payload = cloneDeep(destList);
    if (some(payload, elem => elem.id === partner.id)) {
      const partnerIndex = findIndex(payload, elem => elem.id === partner.id);
      Object.assign(payload[partnerIndex], {
        attributes: partner.attributes,
      });
    } else {
      payload = [...destList, partner];
    }
  }
  dispatch({
    type: types.SET_DESTINATION_DETAILS,
    payload,
  });
};

export const _setUpdatedCampaignList = campaignList => dispatch => {
  dispatch({
    type: types.GET_DE_CAMPAIGNLIST_SUCCESS,
    response: _sortCampaignList(campaignList),
  });
};

export const _getLiveStatus = async (accountId, campaignId, impersonateMode) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/jiraStatus/${accountId}/${campaignId}?impersonateMode=${impersonateMode}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.data.status !== 200) {
      toastError(response.data.message);
      return false;
    }
    if (response.data && response.data.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get Campaign List');
    return false;
  }
};

export const _cancelDistCampaign = async (accountId, campaignId) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/updateJiraStatus/${accountId}/${campaignId}`;
  try {
    const response = await axios({
      url,
      method: 'post',
      responseType: 'json',
      withCredentials: true,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.data.status !== 200) {
      toastError(response.data.message);
      return false;
    }
    if (response.data && response.data.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to cancel distribute campaign.');
    return false;
  }
};

export const resetDestErrors = () => async dispatch => {
  dispatch({
    type: types.RESET_DE_DISTRIBUTE_ERRORS,
  });
};

export const _updateStatus = updatedCampaign => (dispatch, getState) => {
  const state = getState();
  const data = cloneDeep(state.deDistribute.distributeData.data);
  const campaignList = [];
  data.map(item => {
    const c = item;
    if (String(item.id) === String(updatedCampaign.campaignId)) {
      c.status = String(updatedCampaign.status);
    }
    campaignList.push(c);
    return null;
  });
  if (String(state.deDistribute.distRequest.requestId) === String(updatedCampaign.campaignId)) {
    dispatch({
      type: types.SET_DE_DISTREQUEST_STATUS,
      status: String(_getCampaignStatus(updatedCampaign.status)),
    });
  }
  dispatch({
    type: types.GET_DE_CAMPAIGNLIST_UPDATED,
    updatedCampaign,
  });
  dispatch({
    type: types.GET_DE_CAMPAIGNLIST_SUCCESS,
    response: campaignList,
  });

  setTimeout(() => {
    dispatch({
      type: types.GET_DE_CAMPAIGNLIST_UPDATED,
      updatedCampaign: null,
    });
  }, 800);
};

export const setDeleteRequest = (isDeleteRequest, isDeleteRequestId, isDeleteRequestName) => async dispatch => {
  dispatch({
    type: types.SET_DE_DIST_DELETE_REQUEST,
    isDeleteRequest,
    isDeleteRequestId,
    isDeleteRequestName
  });
};

export const _deleteDistributeCampaign = async (accountId, reqParam) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/deleteCampaign/${accountId}`;
  try {
    const response = await axios({
      url,
      method: 'post',
      responseType: 'json',
      withCredentials: true,
      data: reqParam,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.data.status !== 200) {
      toastError(response.data.message);
      return false;
    }
    if (response.data.data && response.data.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to delete campaign.');
    return false;
  }
};

export const deleteDistributeCampaign = () => async (dispatch, getState) => {
  const state = getState()
  const accountId = state.account.activeAccountId;
  const isDeleteRequestId = state.deDistribute.isDeleteRequestId;
  const reqParam = {
    id: isDeleteRequestId
  }
  const deleteRes = await _deleteDistributeCampaign(accountId, reqParam);
  let distRequestReset = false
  if (deleteRes && deleteRes.status === '-1') {
    const data = cloneDeep(state.deDistribute.distributeData.data);
    const deleteIndex = findIndex(
      data,
      item => item.id === isDeleteRequestId
    );
    if( deleteIndex > -1){
      data.splice(deleteIndex, 1);
    }
    if(state.deDistribute.distRequest.requestId === isDeleteRequestId){
      distRequestReset = true
    }
    dispatch({
      type: types.SET_DE_DELETE_CAMPAIGN_SUCCESS,
      payload: data,
      distRequestReset
    });
    dispatch(setDeleteRequest(false, null, ''));
  } else {
    toastError('Deletion failed');
    return false;
  }
};

export const getDesinationPassword = (campaignId, destinationId) => async () => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/getPasswordForDestinations/${campaignId}?destinationId=${destinationId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'text',
      withCredentials: true,
    });
    if (response.status === 500) {
      toastError(response.message);
      return false;
    }
    if (response.data && response.status === 200) {
      CopyDataToClipBoardModal(response.data)
      return true
    }
  } catch (error) {
    toastError('Api failed to get password for destinations');
    return false;
  }
};

export const setComfirmRequest = (isConfirmRequest) => async dispatch => {
  dispatch({
    type: types.SET_DE_DIST_CONFIRM_REQUEST,
    isConfirmRequest
  });
};